'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Memoizer = exports.DEFAULT_TTL = undefined;
exports.getKey = getKey;
exports.expired = expired;
exports.memoize = memoize;

var _jsMd = require('js-md5');

var _jsMd2 = _interopRequireDefault(_jsMd);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = {}; // Memory.

var DEFAULT_TTL = exports.DEFAULT_TTL = 180 * 1000; // 3 minutes, in milliseconds.

function getKey(fn, args) {
  if (typeof fn !== 'function') {
    throw new Error('Parameter `fn` must be a function.');
  }
  var keyArgs = typeof args !== 'undefined' ? args : null;
  return (0, _jsMd2.default)([fn.toString(), JSON.stringify(args)].join(''));
}

function expired(key, ttl) {
  return !cache[key] || Math.abs(Date.now() - cache[key].tstamp) >= ttl;
}

function memoize(fn, ttl, verbose) {
  ttl = ttl || ttl === 0 ? ttl : DEFAULT_TTL;

  return function () {
    var args = [].concat(Array.prototype.slice.call(arguments));
    var key = getKey(fn, args);

    if (!cache[key] || expired(key, ttl)) {
      verbose && console.log('Applying ' + (fn.name || 'anon') + ', cache key=' + key);
      cache[key] = {
        value: _lodash2.default.memoize(function (key) {
          return fn.apply(null, args);
        }),
        tstamp: Date.now()
      };
    } else if (verbose) {
      console.log('Memoized ' + (fn.name || 'anon') + ', cache key=' + key);
    }

    return cache[key].value(key);
  };
}

// For testing.
var Memoizer = exports.Memoizer = {
  DEFAULT_TTL: DEFAULT_TTL,
  memoize: memoize,
  expired: expired,
  getKey: getKey
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/Memoizer.js
// module id = 419
// module chunks = 0